<template>
  <div class="calendar">
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="title-box flex">
          <div >请选择轨迹查询日期(1票/1次)</div>
          <div @click="gotodayBtn">回到今天</div>
        </div>
        <div class="select-date-box flex">
          <div class="left-icon icon-btn" @click="lastMonthBtn">
            <img src="../../assets/images/hisTrack/left-date.png" alt="" srcset="">
          </div>
          <div class="date">{{ selectDate }}</div>
          <div class="right-icon icon-btn" @click="nextMonthBtn">
            <img src="../../assets/images/hisTrack/right-date.png" alt="" srcset="">
          </div>
        </div>
        <div class="week flex">
          <div class="day-box" v-for="item in weekData" :key="item">{{ item }}</div>
        </div>
        <div class="day-list flex" v-for="(item, index) in dateData" :key="index + 1">
          <div @click="selectDay(item[0])" class="day-box" :class="{ active: item[0].is_active, disabled: item[0].disabled }">{{ item[0].day }}</div>
          <div @click="selectDay(item[1])" class="day-box" :class="{ active: item[1].is_active, disabled: item[1].disabled }">{{ item[1].day }}</div>
          <div @click="selectDay(item[2])" class="day-box" :class="{ active: item[2].is_active, disabled: item[2].disabled }">{{ item[2].day }}</div>
          <div @click="selectDay(item[3])" class="day-box" :class="{ active: item[3].is_active, disabled: item[3].disabled }">{{ item[3].day }}</div>
          <div @click="selectDay(item[4])" class="day-box" :class="{ active: item[4].is_active, disabled: item[4].disabled }">{{ item[4].day }}</div>
          <div @click="selectDay(item[5])" class="day-box" :class="{ active: item[5].is_active, disabled: item[5].disabled }">{{ item[5].day }}</div>
          <div @click="selectDay(item[6])" class="day-box" :class="{ active: item[6].is_active, disabled: item[6].disabled }">{{ item[6].day }}</div>
        </div>
      </div>
      <div class="btn-box flex">
        <div class="btn cancle-btn" @click="showDialog = false">取消</div>
        <div class="line"></div>
        <div class="btn define-btn" @click="confirmBtn">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {},
  data() {
    return {
      showDialog: false,
      weekData: ['日', '一', '二', '三', '四', '五', '六'],
      dateData: [],
      selectDayData: null, // 选择的日
      date: moment().format('YYYY-MM'),
      selectDate: moment().format('YYYY年MM月')
    };
  },
  methods: {
    /**
     * 显示日历弹框
     * 设置今日时间
    */
    showPopup () {
      this.showDialog = true
      this.gotodayBtn()
    },


    // 设置月的天数
    setDays () {
      this.currentWeekday = moment(this.date).date(1).weekday() // 获取当月1日为星期几
      this.lastMonthDays = moment(this.date).subtract(1, 'month').daysInMonth() // 获取上月天数
      this.currentMonthDays = moment(this.date).daysInMonth() // 获取当月天数
      const todayDate = moment().format('YYYY-MM-DD')
      const sixmonthDate = moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD')
      //总天数是31，1号是周五或者周六6个[]
      //总天数是30，1号是周六6个[]
      let daysArr
      if((this.currentMonthDays == '31' && this.currentWeekday == '5' || this.currentWeekday == '6' ) || (this.currentMonthDays == '30' && this.currentWeekday == '6')){
        daysArr = [[], [], [], [], [], []]
      }else{
        daysArr = [[], [], [], [], []]
      }
      const getDay = day => (day <= this.lastMonthDays ? '' : (day <= (this.lastMonthDays + this.currentMonthDays)) ? day - this.lastMonthDays : '') // 日期处理
      for (let i = 0; i < 7; i += 1) {
        let virtualDay = (this.lastMonthDays - this.currentWeekday) + i + 1
        for (let j = 0; j < daysArr.length; j += 1) {
          const countDay = getDay(virtualDay + (j * 7))
          const _countDay = this.addPreZero(countDay)
          daysArr[j][i] = {
            day: countDay,
            disabled: `${this.date}-${_countDay}` > todayDate || `${this.date}-${_countDay}` < sixmonthDate,
            is_active: `${this.date}-${_countDay}` === todayDate
          }
        }
      }
      this.dateData = daysArr
    },

    // 设置用户选择的天
    selectDay (data) {
      if (data.disabled) {
        return
      }
      this.selectDayData = this.addPreZero(data.day)
      data.is_active = true
      this.dateData.forEach(item => {
        item.forEach(ele => {
          if (ele.day !== data.day) {
            ele.is_active = false
          }
        })
      })
    },

    // 设置上个月的日期
    lastMonthBtn () {
      const lastMonth = moment(this.date).subtract(1,'months')
      this.date = lastMonth.format('YYYY-MM')
      this.selectDate = lastMonth.format('YYYY年MM月')
      this.setDays()
    },

    // 设置下个月的日期
    nextMonthBtn () {
      const nextMonth = moment(this.date).add(1, 'months')
      this.date = nextMonth.format('YYYY-MM')
      this.selectDate = nextMonth.format('YYYY年MM月')
      this.setDays()
    },

    /**
     *
     * 回到今天
    */

    gotodayBtn () {
      this.date = moment().format('YYYY-MM')
      this.selectDate = moment().format('YYYY年MM月')
      this.selectDayData = moment().format('DD')
      this.setDays()
    },

    /**
     * 判断是否小于10，小于补0
     * @param num 传的数字
    */
    addPreZero (num) {
      if (num < 10) {
        return '0' + num
      } else {
        return num
      }
    },

    /**
     *
     * 确定事件
     * 通知父组件显示选择的日期
    */
    confirmBtn  () {
      this.showDialog = false
      const date = `${this.date}-${this.selectDayData}`
      this.$emit('confirm', date)
    }
  }
}
</script>

<style scoped lang="scss">
.calendar>:first-child {
  background-color: rgba(0,0,0,.4)
}
.calendar>:nth-child(2){
  width: 80%;
  border-radius: 12px;
}
.calendar {
  .content {
    padding: 30px 30px;
    .title-box {
      font-size: 26px;
      justify-content: space-between;
      :first-child {
        color: #333333;
      }
      :last-child {
        color: #5572FD;
        text-decoration:underline;
      }
    }
    .select-date-box {
      margin-top: 30px;
      justify-content: center;
      align-items: center;
      .date {
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        padding: 0 40px;
        padding-top: 4px;
      }
      .icon-btn {
        img {
          width: 20px;
        }
      }
    }
    .day-box {
      color: #333333;
      font-size: 24px;
      flex: .16;
      text-align: center;
    }
    .week {
      padding-top: 50px;
      .day-box {
        font-weight: bold;
      }
    }
    .day-list {
      padding-top: 10px;
      .day-box {
        padding: 26px 0;
      }
      .active {
        background-color: #F3F4FF;
        color: #3C9DFF;
        border-radius: 50%;
      }
      .disabled {
        color:rgba(51, 51, 51, .2);
      }
    }
  }
  .btn-box {
    background-color: #EDEEFC;
    font-size: 36px;
    position: relative;
    .btn {
      flex: 1;
      text-align: center;
      padding: 30px 0;
    }
    .line {
      width: 1px;
      height: 60%;
      position: absolute;
      left: 50%;
      top: 18%;
      background-color: #5277FD;
    }
    .cancle-btn {
      color: #989898;
    }
    .define-btn {
      color: #5277FD;
    }
  }
}
</style>
